<template>
  <div>
    <hr />
    <div class="d-flex justify-content-center">
      <div class="badge badge-dark bg-cr-red-black ml-3 mr-3">
        <div class="badge-number">
          {{ $t('phrase.your_answer') }}: {{ value }}
        </div>
      </div>
      <div class="badge badge-dark bg-cr-red-black">
        {{ $t('word.average') }}: {{ average }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumericAverage',
  props: {
    value: {
      required: true,
      type: Number,
    },
    average: {
      required: true,
      type: Number,
    },
  },
};
</script>
